/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 * Created Date: Sunday, 28th July 2019
 *
 *  Portal - Login Page: Sign Up View
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

// Material UI
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { Typography } from '@material-ui/core';
import VendorIcon from '@material-ui/icons/TransferWithinAStation';
import HospitalIcon from '@material-ui/icons/LocalHospital';
import { useStores } from 'stores/RootStore';

// TODO: Change to pure functional component
const SignUp = props => {
  const { classes } = props;
  const stores = useStores();
  stores.appStore.setView('SignUp');

  return (
    <div className={classes.root}>
      <Grid container direction='column'>
        <Grid item className={classes.formGridItem}>
          <Typography variant='h5' color='primary'>
            Customer Registration
          </Typography>
          <Grid item xs={12}>
            <Typography variant='body2' className={classes.subTitle}>
              Choose your registration type.
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container direction='row' justify='center' alignItems='center'>
            <Grid item xs={12} sm={6} className={classes.typeWrapper}>
              <Button
                variant='contained'
                color='primary'
                component={Link}
                to='/login/sign-up?type=vendor'
                className={classes.iconWrapper}
              >
                <Grid container direction='column' justify='center' alignItems='center'>
                  <Grid item xs={12}>
                    Vendor
                  </Grid>
                  <Grid item xs={12}>
                    <VendorIcon />
                  </Grid>
                </Grid>
              </Button>
            </Grid>
            <Grid item xs={12} sm={6} className={classes.typeWrapper}>
              <Button
                variant='contained'
                color='primary'
                component={Link}
                to='/login/sign-up?type=practice'
                className={classes.iconWrapper}
              >
                <Grid container direction='column' justify='center' alignItems='center'>
                  <Grid item xs={12}>
                    Medical Practice
                  </Grid>
                  <Grid item xs={12}>
                    <HospitalIcon />
                  </Grid>
                </Grid>
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container justify='center' direction='column' className={classes.wrapperFooter}>
        <Grid item>
          <Typography>Already have an account?</Typography>
        </Grid>
        <Grid item>
          <Button component={Link} to='/login' color='primary'>
            Sign In
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

SignUp.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const styles = theme => ({
  root: {},
  buttonWrapper: {
    position: 'relative',
  },
  formGridItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '20px',
    textAlign: 'center',
  },
  formInput: {
    minWidth: '265px',
    marginBottom: '8px',
    fontSize: '12pt',
  },
  button: {
    marginTop: '25px',
    marginBottom: '15px',
    fontSize: '12pt',
  },
  buttonProgress: {
    zIndex: 1,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -8,
    marginLeft: -15,
  },
  iconButton: {
    color: theme.palette.type === 'light' ? 'rgb(128, 128, 128)' : theme.palette.common.white,
    padding: '0',
  },
  subTitle: {
    color: theme.palette.text.primary,
    marginTop: '5px',
    paddingRight: '10px',
    paddingLeft: '10px',
  },
  iconWrapper: {
    margin: '15px',
    width: '120px',
    height: '120px',
    '& svg': {
      width: '55px',
      height: '55px',
    },
    '& .fab,& .fas,& .far,& .fal,& .material-icons': {
      width: '55px',
      fontSize: '55px',
    },
  },
  wrapperFooter: {
    marginTop: '20px',
  },
  grow: {
    flexGrow: 1,
    width: '100%',
  },
  navLink: {
    '&:link, &:visited': {
      textDecoration: 'none',
      color: theme.palette.text.primary,
    },
    '&:hover': {
      color: theme.palette.primary,
    },
    '&:active': {
      color: theme.palette.primary,
    },
  },
});

export default withStyles(styles, { withTheme: true })(observer(SignUp));
